// Modules
import React, {useState} from 'react';

// Styles
import classes from './HomeUI.module.scss';

// Components
import Header from "./Header";
import Footer from "./Footer";
import SupportSection from "./SupportSection";

// Constants
import {allFAQs} from "../constants/faqConstants";


const FaqUI = () => {
    const [openedFaqIndex, setOpenedFaqIndex] = useState(0);

    return (
        <main className="main">
            <Header/>

            <div className={'pagePad__x padTop--l5 padBottom--l8'}>
                <h1 id='faq' className="sectionHeading text__align--center">FAQs</h1>

                <div className="marginTop--l4">
                    {allFAQs.map((item, index) => (
                        <div key={index} className={`${classes.faqWidget} ${index > 0 ? 'marginTop--l3' : ''}`} onClick={() => setOpenedFaqIndex(index===openedFaqIndex ? -1 : index)}>
                            <div className="display--flex flex__justifyContent--between flex__alignItems--center cursor--pointer">
                                <h2 className={classes.desc}>{item.title}</h2>

                                <img src="/assets/icons/downArrow.svg" alt="Down arrow icon" style={{ rotate: index===openedFaqIndex ? '180deg' : '0deg', marginLeft: 8 }} />
                            </div>

                            {index===openedFaqIndex && <h3 className={`${classes.desc} marginTop--l4 padTop--l4`}
                                            style={{ borderTop: '1px solid rgba(0,0,0,0.05)', color: '#7c7c7c' }} dangerouslySetInnerHTML={{__html: item.desc}}></h3>}
                        </div>
                    ))}
                </div>

                <div className='marginTop--l12'>
                    <SupportSection/>
                </div>
            </div>

            <Footer/>
        </main>
    );
};

export default FaqUI;
